import { useState, useContext, useEffect } from "react";
import "../../../styles/casedetails.css";
import { Outlet, Link, useNavigate, Navigate } from "react-router-dom";
import { ShareContext } from "../../../context/ShareContext";
import * as Constants from "../../../constants";
import JisButton from "../../controls/jisButton";

function ViewClaims({ caseId, claims = null, isAction = false }) {
  const navigate = useNavigate();
  const { activePage, token, profile, frequentData, setIsExpired } =
    useContext(ShareContext);
  const [loading, setLoading] = useState(false);
  const [_claims, setClaims] = useState(claims);

  useEffect(() => {
    /*   if(claims==null){
               onLoad();
              }
   */
  }, [claims]);

  const onLoad = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/case-details/${caseId}/caseinfo`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await resp.json();
      if (data.code == 0) {
        setClaims(data.claims);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onFilingClaim = () => {
    navigate(`/filing-claim/${caseId}`);
  };

  const onFilingCounter = (claim) => {
    navigate(`/filing-claim/${caseId}/${claim.id}`);
  };
  return (
    <div>
      {isAction && (
        <div
          style={{ textAlign: "right", marginBottom: "21px" }}
          className="case-details-table-button"
        >
          <JisButton onClick={onFilingClaim}>
            {/* CLICK HERE TO FILE ADDITIONAL COUNTER CLAIMS */} Add Claim
          </JisButton>
        </div>
      )}

      <div className="table-header">
        <p>Claim </p>
      </div>
      <div className="table-wrapper">
        <table class="case-details-table">
          <thead>
            <tr>
              <th className="col-title">Claim/Offences</th>
              <th className="col-title">Party Name</th>
              <th className="col-action">Action</th>
            </tr>
          </thead>

          <tbody>
            {_claims.map((item) => (
              <tr key={item.id}>
                <td>{item.claim || "N/A"} </td>
                <td>
                  {item?.party?.firstName || item?.party?.lastName
                    ? `${item.party?.firstName} ${item.party?.lastName ?? ""}`
                    : "N/A"}
                  {/* {item.party.firstName} {item.party.lastName ?? ""} */}
                </td>
                <td>
                  {isAction ? (
                    <JisButton onClick={() => onFilingCounter(item)}>
                      Add Counter Claims
                    </JisButton>
                  ) : (
                    "N/A"
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* <div className="motion-cards">
        {_claims.map((opt) => (
          <div class="motion-card" key={opt.id}>
            <div class="motion-section">
              <div class="motion-left">
                <p>
                  <strong>Claims/Offence</strong>
                </p>
                <p>{opt.claim} </p>
              </div>
              <div class="motion-divider"></div>
              <div class="motion-right">
                {!(opt.claimValue == null || opt.claimValue == "") && (
                  <p>
                    <strong>Value: </strong>{" "}
                    {Constants.formatCurrency(opt.claimValue)}
                  </p>
                )}
                <p>
                  <strong>Party Name: </strong> {opt.party.firstName}{" "}
                  {opt.party.lastName ?? ""}
                </p>
                {isAction && (
                  <JisButton onClick={() => onFilingCounter(opt)}>
                    Counter Claims
                  </JisButton>
                )}
              </div>
            </div>
          </div>
        ))}
      </div> */}
    </div>
  );
}

export default ViewClaims;
